module.exports = __webpack_public_path__ + "img/popular3.28131738.png";